import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { MaskLines } from "../motion";
import { IMG } from "../assets";

export default function NotFound() {
  return (
    <section className="relative min-h-[100svh] bg-ink text-bone grid place-items-center grain overflow-hidden">
      <img src={IMG.hero} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/60" />
      <div className="relative text-center px-6">
        <div className="eyebrow text-gold mb-6">Erro 404</div>
        <h1 className="display text-6xl lg:text-8xl mb-6"><MaskLines lines={["Esta página não", "foi encontrada."]} /></h1>
        <p className="text-bone/60 max-w-md mx-auto mb-10 font-light">O endereço pode ter sido alterado ou não estar mais disponível. Utilize o menu para continuar a navegação.</p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Link to="/" data-testid="notfound-home" className="btn-gold"><ArrowLeft size={16} /> Voltar ao início</Link>
          <Link to="/atuacao" data-testid="notfound-atuacao" className="btn-ghost">Conheça nossa atuação <ArrowRight size={16} /></Link>
        </div>
      </div>
    </section>
  );
}
